export const uploadData = (data) => ({
  type: 'UPLOAD_DATA',
  payload: data,
});

export const uploadFile = (file) => {
  if (file) {
    const { name, lastModified } = file;
    return {
      type: 'UPLOAD_FILE',
      payload: {
        name,
        lastModified
      }
    };
  }
  return {
    type: 'UPLOAD_FILE',
    payload: null,
  }
}

export const updateTab = (data) => ({
  type: 'UPDATE_TAB',
  payload: data,
});
